export const legacyReports = [
  {
    id: "expanded-ecr",
    name: "Expanded ECR Assignment Report",
    description: "View data about ECR assignments",
    variant: "legacy" as const,
    slug: "expanded-ecr-assignment-report",
  },
];
